// import { toJS } from "mobx";
// import { useObserver } from "mobx-react";
// import { useStores } from "../../store";

// export default function Select(props) {
//   const { RecuiterStore } = useStores();

//   // Handle value change
//   const handleChange = (e) => {
//     const selectedValue = e.target.value;
//     if (props.action) {
//       props.action(e); // Call parent-provided action to handle state update
//     } else {
//       console.warn("No action function provided to handle the change.");
//     }
//     console.log(`Selected Value: ${selectedValue}`); // Debugging
//   };

//   return useObserver(() => (
//     <div className="flex flex-col gap-1 text-lg">
//       <label
//         className="font-medium text-base ml-3 text-gray-500"
//         onDoubleClick={props.onDoubleClick}
//         onClick={() => {
//           console.log("RecuiterStore:", toJS(RecuiterStore.jobPostDetails));
//           console.log("Props passed to Select component:", toJS(props));
//         }}
//       >
//         {props.label}
//       </label>
//       <div className="relative">
//         <select
//           value={props.value || ""} // Ensure value is controlled
//           onChange={handleChange} // Trigger parent action
//           className={`appearance-none border px-4 pr-10 rounded-lg text-base focus:outline-none border-[#c9c9c9] w-full ${
//             props.height || "h-[3.5rem]" // Default height is `h-10` if no `height` prop is passed
//           }`}
//         >
//           {/* Placeholder Option */}
//           <option value="" disabled={!props.value}>
//             {props.placeholder || "Select an option"}
//           </option>

//           {/* Options */}
//           {props.options.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.label}
//             </option>
//           ))}
//         </select>

//         {/* Custom Chevron Icon */}
//         <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
//           <svg
//             className="w-4 h-4 text-gray-700"
//             fill="currentColor"
//             viewBox="0 0 20 20"
//           >
//             <path
//               fillRule="evenodd"
//               d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
//               clipRule="evenodd"
//             />
//           </svg>
//         </div>
//       </div>
//     </div>
//   ));
// }
import { toJS } from "mobx";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";

export default function Select(props) {
  const { RecuiterStore } = useStores();
  return useObserver(() => (
    <>
      <div className="flex flex-col gap-2 text-lg tc1:mb-2 sm:mb-0 md:mt-0 tc5:mt-2 tc6:mt-2 tc7:mt-2 tc8:mt-2">
        <label
          className="font-sans text-base ml-3 text-[#6D6B6B]"
          onDoubleClick={props.onDoubleClick}
          onClick={() => {
            console.log(toJS(RecuiterStore.jobPostDetails));
            console.log(toJS(props));
          }}
        >
          {props.label}
        </label>
        <div className="relative ">
          <select
            value={props.value || ""}
            required={props.required || true}
            onChange={(e) => {
              props.action(e);
            }}
            className={`appearance-none  border px-4 pr-10 rounded-lg text-base text-[#BFBFBF] border-[#c9c9c9] min-w-[150px] w-full ${
              props.height || "h-10"
            } ${props.value === "" ? "text-[#BFBFBF]" : "text-black"}`} // Apply gray text when placeholder is active
          >
            <option value="" className="text-gray-500  ">
              {props.placeholder || "Select Level"}
            </option>
            {props.options.map((option) => (
              <option
                key={option.value}
                value={option.value}
                className="text-black"
              >
                {option.label}
              </option>
            ))}
          </select>

          {/* Custom Chevron Icon */}
          {/* <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-700"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div> */}
        </div>
      </div>
    </>
  ));
}
